import React, {Component} from "react";
import {connect} from 'react-redux';

import "../../../asset/style/neoviewer/screenshot.css"
import {Button, Checkbox, Stack, TextField, ToggleButton, ToggleButtonGroup, Typography} from "@mui/material";
import {downloadScreenshot} from "../utils/screenshot_utils";
import {getPrefixedUrlSecure} from "../../../utils/utils"
import {getDicomThumbnails} from "../../../utils/api";
import {toggleZStackScreenshot, updateExtension} from "../../../redux_actions/screenshot.state.action";
import {updateAbstractAppsInstalled} from "../../../redux_actions/morpheus.setting.action";
import {componentIds, ScreenshotExtensions} from "../../../utils/const";
import {AppRow, AppTitle, LoadingText} from "../components/components";
import {get} from "../../../helper/request";
import {Card, Row, Spin} from "antd";
import {DownloadForOfflineRounded} from "@mui/icons-material";
import Title from "antd/es/typography/Title";
import {StyledSwitch} from "../components/StyledComponents";
import {error_manager} from "../../../helper/error_manager";

class ScreenshotApp extends Component {

	constructor(props) {
		super(props);

		this.state = {
			fileName: this.props.slide.name,
			screenshots: [],
			hovered: false,
			focus_stacking_in_progress: false,
			imageData: null,
		}

		this.poller = null;
	}

	componentDidMount() {
		this.fetchZStackScreenshots();
		if (this.props.slide.meta?.takeZStack) {
			this.poller = setInterval(this.fetchZStackScreenshots, 1000);
		}
		if (this.props.is_dicom) {
            getDicomThumbnails(this.props.slide.id, true)
                .then(data => this.setState({imageData: data}))
                .catch(err => {
                    this.setState({imageData: ''})
                    error_manager("", err)
                })
        }
	}

	componentWillUnmount() {
		clearInterval(this.poller);
	}
	fetchZStackScreenshots = () => {
		let url = "/api/get_zstack_screenshots/?slide_id=" + this.props.slide.id;
		get(url)
			.then((res) => {
				this.setState({screenshots: res.images || [], focus_stacking_in_progress: res["in_progress"]});
			})
			.catch(err => {
                error_manager("", err)
			})
	}

	updateExtension = (e, value) =>
		this.props.dispatch(updateExtension(value));

	downloadScreenshot = () => downloadScreenshot(componentIds.slideMaps, this.state.fileName, this.props.extension,
		this.props.displaySetting,
		this.props.morpheusSetting.abstract_configs.add_barcode_in_screenshot === true ? (this.props.is_dicom ? this.state.imageData : getPrefixedUrlSecure(`pre-processed/barcode_crop.jpg`, this.props.slide)): null,
		this.props.barcodeImgCurrentRotation);

	downloadImage = (imageUrl) => {
		let anchor = document.createElement('a');
		anchor.href = imageUrl;
		anchor.download = this.props.slide.name;
		anchor.style.display = 'none';
		anchor.click();
		anchor.remove();
	}

	toggleZStackScreenshotFlag = () => {
		this.props.dispatch(toggleZStackScreenshot(!this.props.zStackScreenshotEnabled));
	}

	getExtensionToggleButton = value =>
		<ToggleButton value={value} sx={{paddingX: 1, paddingY: 0}}>
			<Typography variant={"overline"} color={"whitesmoke"}>{value}</Typography>
		</ToggleButton>
	
	toggleLabelInScreenshot = (e) => {
		const isChecked = e.target.checked
		let abstract_configs = this.props.morpheusSetting.abstract_configs;
		abstract_configs.add_barcode_in_screenshot = isChecked
		this.props.dispatch(updateAbstractAppsInstalled(abstract_configs));
	} 

	render() {
		if (!this.props.slide || !this.props.displaySetting) return <LoadingText/>;
		return <Stack spacing={1.5}>
			<AppTitle title={"Screenshot"}/>
			<AppRow title={"File Name"}>
				<TextField autoFocus color={"secondary"} defaultValue={this.state.fileName} variant={"filled"}
				           onChange={(e) => e.target.value && this.setState({fileName: e.target.value})}/>
			</AppRow>
			<AppRow title={"Extension"}>
				<ToggleButtonGroup value={this.props.extension} exclusive onChange={this.updateExtension}>
					{this.getExtensionToggleButton(ScreenshotExtensions.JPEG)}
					{this.getExtensionToggleButton(ScreenshotExtensions.PNG)}
				</ToggleButtonGroup>
			</AppRow>	
			<AppRow title={"Barcode"}>
				<Checkbox
					checked={this.props.morpheusSetting.abstract_configs.add_barcode_in_screenshot === true}
					onChange={this.toggleLabelInScreenshot}
					color="primary"
					style={{ color: this.props.morpheusSetting.abstract_configs.add_barcode_in_screenshot === true ? 'white' : 'inherit', marginLeft: 0, paddingLeft: 0 }}
				/>
			</AppRow>
			<Button color={"secondary"} variant={"contained"} onClick={this.downloadScreenshot}>
				Save
			</Button>

			{
				this.props.slide.meta?.takeZStack ?
					<>
						<Stack direction={"row"} alignItems="center" justifyContent={"space-between"}>
							<Typography>Enable Z-stack Screenshot</Typography>
							<StyledSwitch color={"secondary"} checked={this.props.zStackScreenshotEnabled} onChange={this.toggleZStackScreenshotFlag}/>
						</Stack>
						<Row>
							<Title level={4} style={{color: "white"}}>Z-Stack Screenshots</Title>
							{
								this.state.focus_stacking_in_progress ? <Spin spinning={true}>{"Processing latest screenshots"}</Spin>:null
							}
							{this.state.screenshots.map((url, index) => (
								<Card
									key={index}
									style={{ width: "95%", margin: 4 }}
									cover={
										<div
											className="image-container"
											onMouseEnter={() => this.setState({hovered: true})}
											onMouseLeave={() => this.setState({hovered: false})}
											style={{ position: 'relative' }}
										>
											<img src={url} alt="Image" className="image" style={{ width: '100%' }} />
											{this.state.hovered && (
												<div onClick={() => {this.downloadImage(url)}} className="overlay" style={{ cursor: "pointer", position: 'absolute', top: 0, left: 0, right: 0,
													bottom: 0, display: "flex", justifyContent: "center", alignItems: "center" }}>
													<DownloadForOfflineRounded fontSize={"large"} />
												</div>
											)}
										</div>
									}>
								</Card>
							))}
						</Row>
					</>
					: null
			}

		</Stack>
	}
}

const mapStateToProps = (state) => {
	let {activeMapId} = state.gammaStateReducer;
	let {extension, zStackScreenshotEnabled, barcodeImgCurrentRotation} = state.screenshotStateReducer;
	let {slide, displaySetting, is_dicom} = state.mapsStateReducer[activeMapId];
	let morpheusSetting = state.morpheusSettingReducer;
	return {activeMapId, extension, slide, displaySetting, zStackScreenshotEnabled, barcodeImgCurrentRotation, morpheusSetting, is_dicom};
}

export default connect(mapStateToProps)(ScreenshotApp);
